<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="groupForm">
		<!-- ROW * -->
		<div class="grid">
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Name, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Name, 'label')">{{ 'NAME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Name, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="mtma-contact-add-input-name"
							formControlName="Name" autocomplete="mtma-contact-add-input-name"
							placeholder="{{ 'NAME' | translate }}" maxlength="40" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Name)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'ONE_WEEKLY_SCHEDULE' | translate }}</div>
					<div class="flex align-items-center justify-content-center h-2rem"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-multiSelect formControlName="WeeklySchedule" [options]="listWeeklySchedule" appendTo="body"
							optionLabel="Name" dataKey="Id" [ngClass]="dynamicInputTextWidth()"
							[styleClass]="dynamicInputTextWidth()" [selectionLimit]="8"
							selectedItemsLabel="{{'SELECTED_ITEM' | translate }}{0}">
						</p-multiSelect>
					</div>
				</div>
				<small
					*ngIf="showDoubleErrorRequiredMessageAndCheck(this.f.WeeklySchedule.value, this.f.SpecialPlanning.value)"
					class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{
					'NEED_ONE_PROGRAMMATION' | translate }}</small>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'SPECIAL_PLANNING' | translate }}</div>
					<div class="flex align-items-center justify-content-center h-2rem"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-multiSelect formControlName="SpecialPlanning" [options]="listSpecialPlanning" appendTo="body"
							optionLabel="Name" dataKey="Id" [ngClass]="dynamicInputTextWidth()"
							[styleClass]="dynamicInputTextWidth()" [selectionLimit]="8"
							selectedItemsLabel="{{'SELECTED_ITEM' | translate }}{0}">
						</p-multiSelect>
					</div>
				</div>
				<small
					*ngIf="showDoubleErrorRequiredMessageAndCheck(this.f.WeeklySchedule.value, this.f.SpecialPlanning.value)"
					class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{
					'NEED_ONE_PROGRAMMATION' | translate }}</small>
			</div>
			<div class="col-12" [class]="onExtendedMobile() ? 'pb-0' : ''">
				<p class="font-bold mb-3 text-center">{{ 'WEEKLYSCHEDULES_ACTIVE' | translate }}</p>
				<div class="flex flex-row align-items-center justify-content-center gap-2 mb-3 border-100 border-bottom-2"
					[class]="onExtendedMobile() ? 'grid' : ''" *ngFor="let weeklySchedule of this.f.WeeklySchedule.value">
					<div class="font-semibold px-3" [class]="onExtendedMobile() ? 'col-12 text-center' : ''">{{
						weeklySchedule.Name }}</div>
					<!--  DATE  -->
					<div class="flex flex-row align-content-center justify-content-center w-15_5rem"
						[class]="onExtendedMobile() ? 'col-12 pt-0' : ''">
						<p-button *ngFor="let day of daysOfWeekSchedule(weeklySchedule);"
							styleClass="p-button-weeklyschedulebgwhite w-2rem h-2rem flex justify-content-center hover:bg-primary cursor-auto"
							[text]="!day.Enable" [disabled]="!day.Enable"
							[severity]="day.Enable === true ? 'primary' : 'primary'"
							label="{{ day.Name | translate | firstLetter }}">
						</p-button>
					</div>
					<!--  TIME  -->
					<div class="flex flex-row align-items-center justify-content-center text-center gap-2"
						[class]="onExtendedMobile() ? 'col-12 pt-0' : ''">
						{{ "DATE_FROM" | translate }}:
						<p class="font-bold">{{ getTime(weeklySchedule.DtFrom) }}</p>
					</div>
					<div class="flex flex-row align-items-center justify-content-center text-center gap-2"
						[class]="onExtendedMobile() ? 'col-12 pt-0' : ''">
						{{ "DATE_TO" | translate }}:
						<p class="font-bold">{{ getTime(weeklySchedule.DtTo)}}</p>
					</div>
				</div>
			</div>

			<div class="col-12" [class]="onExtendedMobile() ? 'py-0' : ''">
				<p class="font-bold mb-3 text-center">{{ 'SPECIALPLANNINGS_ACTIVE' | translate }}</p>
				<div class="flex flex-row align-items-center justify-content-center gap-3 mb-3 border-100 border-bottom-2"
					*ngFor="let specialPlanning of this.f.SpecialPlanning.value" [class]="onExtendedMobile() ? 'grid' : ''">
					<div class="font-semibold" [class]="onExtendedMobile() ? 'col-12 pb-1 text-center' : ''">{{
						specialPlanning.Name }}</div>
					<!--  Access -->
					<div class="flex flex-row justify-content-start align-items-center"
						[class]="onExtendedMobile() ? 'col-12 justify-content-center py-1'  : ''">
						<p-tag
							[value]="specialPlanning.Access ? ('CONTROL_ACCESS_ENTER' | translate) : ('CONTROL_ACCESS_NOT_ENTER' | translate)"
							[severity]="specialPlanning.Access ? 'success' : 'danger'"></p-tag>
					</div><!--  Old Period -->
					<div class="flex flex-row justify-content-start align-items-center"
						[class]="onExtendedMobile() ? 'col-12 justify-content-center py-1'  : ''"
						*ngIf="isOldSpecialPlanning(specialPlanning)">
						<span *ngIf="getRepetitionTimeslice(specialPlanning) === 0">{{
							getLabelRepetition(getRepetitionTimeslice(specialPlanning)) }}</span>
						<p-tag *ngIf="getRepetitionTimeslice(specialPlanning) !== 0"
							[value]="getLabelRepetition(getRepetitionTimeslice(specialPlanning))"
							[styleClass]="getColorRepetition(getRepetitionTimeslice(specialPlanning))"></p-tag>
					</div>
					<!--  Old Programmation -->
					<div class="flex flex-row justify-content-start align-items-center"
						[class]="onExtendedMobile() ? 'col-12 justify-content-center py-1'  : ''"
						*ngIf="isOldSpecialPlanning(specialPlanning)">
						<div class="flex align-items-center justify-content-center">{{
							getDetailsTimeSpecialPlanning(specialPlanning)
							}}
						</div>
					</div>
					<!--  Old Repetition -->
					<div class="flex flex-row justify-content-start align-items-center"
						[class]="onExtendedMobile() ? 'col-12 justify-content-center py-1'  : ''"
						*ngIf="isOldSpecialPlanning(specialPlanning)">
						<div class="flex align-items-center justify-content-center">{{
							getTemporaryTimeslice(specialPlanning) }}
						</div>
					</div>
					<!--  DATE  -->
					<div class="flex flex-row align-items-center justify-content-center text-center gap-2"
						[class]="onExtendedMobile() ? 'col-12 py-1' : ''" *ngIf="!isOldSpecialPlanning(specialPlanning)">
						{{ "FROM" | translate }}:
						<p class="font-bold">{{ specialPlanning.DtFrom.split('T')[0] }}</p>
					</div>
					<div class="flex flex-row align-items-center justify-content-center text-center gap-2"
						[class]="onExtendedMobile() ? 'col-12 py-1' : ''" *ngIf="!isOldSpecialPlanning(specialPlanning)">
						{{ "TO" | translate }}:
						<p class="font-bold">{{ specialPlanning.DtTo.split('T')[0] }}</p>
					</div>
					<!--  TIME  -->
					<div class="flex flex-row align-items-center justify-content-center text-center gap-2"
						[class]="onExtendedMobile() ? 'col-12 py-1' : ''" *ngIf="!isOldSpecialPlanning(specialPlanning)">
						{{ "DATE_FROM" | translate }}:
						<p class="font-bold">{{ specialPlanning.DtFrom.split('T')[1] }}</p>
					</div>
					<div class="flex flex-row align-items-center justify-content-center text-center gap-2"
						[class]="onExtendedMobile() ? 'col-12 pt-1' : ''" *ngIf="!isOldSpecialPlanning(specialPlanning)">
						{{ "DATE_TO" | translate }}:
						<p class="font-bold">{{ specialPlanning.DtTo.split('T')[1] }}</p>
					</div>
				</div>
			</div>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>